import React, { useEffect, useState } from "react";
import { getPurchaseOrder } from "../../actions/project-management.action";
import idx from "idx";
import { numberFormat } from "../../util/currency-formatter";
import Table from "react-bootstrap/Table";
import moment from "moment";
import { useDispatch } from "react-redux";
import { Button } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import { VENDOR_TAB, VENDOR_URL_PARAM } from "../../constants/vendor.contant";

function ViewPurchaseOrderComponent({
  poId,
  cancelHandler,
  editHandler,
  sourcePage,
}) {
  const [PO, setPO] = useState({});
  const [vendorType, setvendorType] = useState();
  const [total, setTotal] = useState(0);
  const [attachments, setAttachments] = useState([]);

  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (poId) getPO();
  }, [poId]);

  const getPO = async () => {
    const query = `?poId=${poId}`;
    let res = await dispatch(getPurchaseOrder(query));
    setPO(res);
    setvendorType(idx(res, (_) => _.vendor.type));
    let totalCost = 0;
    Array.isArray(res.items) &&
      res.items.forEach(({ total }) => (totalCost += total));
    setTotal(totalCost);
    const attachmentList = Array.isArray(idx(res, (_) => _.attachment))
      ? idx(res, (_) => _.attachment)
      : [];
    const attachment = attachmentList.map((item) => {
      return (
        <div className="attachedFiles">
          <p style={{ margin: "0 10px 0 0" }}>{item.name}</p>
        </div>
      );
    });
    setAttachments(attachment);
  };

  // Determine if edit should be enabled based on source page and status
  const isEditEnabled = () => {
    const returnTab = searchParams.get(VENDOR_URL_PARAM.RETURN_TAB);
    const poStatus = idx(PO, _ => _.status);
    const materialStatus = idx(PO, _ => _.materialstatus);

    // Backend may return '1'/'2'/'3' (DB codes) or 'None Received'/'Partially Received'/'Fully Received'
    const isNoneReceived = materialStatus === 'None Received' || materialStatus === '1' || materialStatus === 1;

        // If coming from Orders List (vendor orders page) - check PO Status
    if (returnTab === VENDOR_TAB.PURCHASE_ORDERS || sourcePage === 'orders-list') {
      return poStatus === 'Pending';
    }

    // If coming from Project PO List (project execution) - check Material Status
    if (sourcePage === 'project-po-list' || (!returnTab && !sourcePage)) {
      return isNoneReceived;
    }

    // Default fallback - use existing logic
    return poStatus === 'Pending';
  };

  // Get appropriate edit button message based on source
  const getEditButtonMessage = () => {
    const returnTab = searchParams.get(VENDOR_URL_PARAM.RETURN_TAB);

    // If coming from Orders List (vendor orders page)
    if (
      returnTab === VENDOR_TAB.PURCHASE_ORDERS ||
      sourcePage === "orders-list"
    ) {
      return "Only Pending POs can be edited.";
    }

    // If coming from Project PO List (project execution)
    if (sourcePage === "project-po-list" || (!returnTab && !sourcePage)) {
      return "Only POs with None Received Stocks can be edited.";
    }

    // Default message
    return "Only Pending POs can be edited.";
  };

  return (
    <>
      <div className="row" data-cy="po-details">
        <div className="col-4 mt-3">
          <div className="view-block" data-cy="po-no">
            <label>Purchase Order Number</label>
            {/* f_id is the PO number with project prefix and Suffix if null then default to po Number*/}
            <p>{PO.f_id || PO.id}</p>
          </div>
        </div>
        <div className="col-4 mt-3">
          <div className="view-block" data-cy="vendor-type">
            <label>Vendor Type</label>
            <p>{vendorType}</p>
          </div>
        </div>
        <div className="col-4 mt-3">
          <div className="view-block" data-cy="vendor-name">
            <label>Vendor Name</label>
            <p>{idx(PO, (_) => _.vendor.business_name) || "-"}</p>
          </div>
        </div>
        <div className="col-4 mt-3">
          <div className="view-block" data-cy="quote-no">
            <label>Quote No</label>
            <p>{PO.quoteNo || "-"}</p>
          </div>
        </div>
        {idx(PO, (_) => _.rfq.description) && (
          <div className="col-lg-4 mt-3">
            <div className="view-block" data-cy="description">
              <label>Description</label>
              <p>{idx(PO, (_) => _.rfq.description)}</p>
            </div>
          </div>
        )}
        {idx(PO, (_) => _.quotation.id) && (
          <div className="col-4 mt-3">
            <div className="view-block" data-cy="quote-request-no">
              <label>Quote Request No</label>
              <p>{idx(PO, (_) => _.quotation.id)}</p>
            </div>
          </div>
        )}
        {PO.quoteNo && (
          <div className="col-4 mt-3">
            <div className="view-block" data-cy="quote-no">
              <label>Quote No</label>
              <p>{PO.quoteNo}</p>
            </div>
          </div>
        )}

        <div className="col-4 mt-3">
          <div className="view-block" data-cy="delivery-date">
            <label>Delivery Date</label>
            <p>
              {idx(PO, (_) => _.deliveryDate)
                ? moment(idx(PO, (_) => _.deliveryDate)).format("DD/MM/YYYY")
                : "-"}
            </p>
          </div>
        </div>

        <div className="col-4 mt-3">
          <div className="view-block" data-cy="date-ordered">
            <label>Date Ordered</label>
            <p>
              {(() => {
                const createdAt = idx(PO, (_) => _.createdAt);
                return createdAt ? moment(createdAt).format("DD/MM/YYYY") : "-";
              })()}
            </p>
          </div>
        </div>

        <div className="col-4 mt-3">
          <div className="view-block" data-cy="delivery-option">
            <label>Delivery Option</label>
            <p>{idx(PO, (_) => _.deliveryOption) || "-"}</p>
          </div>
        </div>
        <div className="col-4 mt-3">
          <div className="view-block" data-cy="notes">
            <label>Notes</label>
            <p>{idx(PO, (_) => _.notes) || "-"}</p>
          </div>
        </div>
        <div className="col-4 mt-3">
          <div className="view-block" data-cy="street-address">
            <label>Street Address</label>
            <p>{idx(PO, (_) => _.street_address) || "-"}</p>
          </div>
        </div>
        <div className="col-4 mt-3">
          <div className="view-block" data-cy="suburb">
            <label>Suburb</label>
            <p>{idx(PO, (_) => _.suburb) || "-"}</p>
          </div>
        </div>
        <div className="col-4 mt-3">
          <div className="view-block" data-cy="state">
            <label>State</label>
            <p>{idx(PO, (_) => _.state) || "-"}</p>
          </div>
        </div>
        <div className="col-4 mt-3">
          <div className="view-block" data-cy="postcode">
            <label>Postcode</label>
            <p>{idx(PO, (_) => _.postcode) || "-"}</p>
          </div>
        </div>
        <div className="col-4 mt-3">
          <div className="view-block" data-cy="country">
            <label>Country</label>
            <p>{idx(PO, (_) => _.country) || "-"}</p>
          </div>
        </div>
        <div className="col-4 mt-3">
          <div className="view-block" data-cy="total">
            <label>Total</label>
            <p>{numberFormat(total)}</p>
          </div>
        </div>
        {idx(PO, (_) => _.is_credit_invoice) && (
          <div className="col-4 mt-3">
            <div className="view-block">
              <label>Credit Invoice</label>
              <p>
                {numberFormat(idx(PO, (_) => _.receive_credit_amount) || 0)}
              </p>
            </div>
          </div>
        )}
        <div className="col-lg-4 mt-3">
          <div className="view-block" data-cy="attachments">
            <label>Attachments</label>
            <p>{attachments}</p>
          </div>
        </div>
      </div>

      <div className="material-list-block mt-3" data-cy="material-list">
        <div className="table-responsive">
          <Table
            bordered
            className="table-create table-material table-material-ch"
          >
            <thead>
              <tr>
                <th className="w-auto" data-cy="task">
                  Task
                </th>
                <th className="w-auto" data-cy="item">
                  Item
                </th>
                <th className="w-auto" data-cy="manufacturer">
                  Manufacturer
                </th>
                <th data-cy="part-no">Part Number</th>
                <th data-cy="qty">Qty</th>
                <th data-cy="qty-received">Qty Received</th>
                <th className="text-right" data-cy="quotation">
                  Quotation
                </th>
              </tr>
            </thead>
            <tbody data-cy="material-list-body">
              {(PO.items || []).map((item) => (
                <tr key={item.id} data-cy="material-list-item">
                  <td data-cy="task">{item.taskName}</td>
                  <td data-cy="item">{item.item}</td>
                  <td data-cy="manufacturer">{item.manufacturer}</td>
                  <td data-cy="part-no">{item.partNo}</td>
                  <td data-cy="qty">{item.qty}</td>
                  <td data-cy="qty-received">{item.receivedQty}</td>
                  <td className="text-right" data-cy="quotation">
                    {numberFormat(item.total)}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
      <div className="col-12 d-flex mt-3 justify-content-end">
        <Button
          type="button"
          onClick={isEditEnabled() ? editHandler : () => {}}
          className={`bg-brand-1 me-3 ${!isEditEnabled() ? "disabled" : ""}`}
          data-cy="edit-button"
          title={!isEditEnabled() ? getEditButtonMessage() : ""}
        >
          EDIT
        </Button>
        <Button
          type="button"
          onClick={cancelHandler}
          className="secondarybtn cancelbtn"
          data-cy="cancel-button"
        >
          CANCEL
        </Button>
      </div>
      {!isEditEnabled() && (
        <div className="text-right mt-1" data-cy="edit-warning">
          <em className=" text-nowrap brand-color-1 fst-12 fw-semibold">
            *{getEditButtonMessage()}
          </em>
        </div>
      )}
    </>
  );
}

export default ViewPurchaseOrderComponent;
